<div class="modal-header">
  <h4 class="modal-title" id="modal-basic-title">
    {{'bikeshop.modal.component.connect_pos' | translate }}
  </h4>
  <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
    <span class="hubtiger-close"></span>
  </button>
</div>
<div class="modal-body">
  <div class="row">
    <div class="col-md-12">
      <div *ngIf="partner && selectPOS && selectPOS.POSID===3">
        <app-link-vend [partner]="partner" [selectedPOS]="selectPOS"></app-link-vend>
      </div>
      <div *ngIf="partner && selectPOS && selectPOS.POSID===6">
        <app-link-lightspeed [partner]="partner" [selectedPOS]="selectPOS">
        </app-link-lightspeed>
      </div>
      <div *ngIf="partner && selectPOS && selectPOS.POSID===8">
        <app-link-xero [partner]="partner" [selectedPOS]="selectPOS"></app-link-xero>
      </div>
      <div *ngIf="partner && selectPOS && selectPOS.POSID===9">
        <app-link-shopify [partner]="partner" [selectedPOS]="selectPOS"></app-link-shopify>
      </div>
      <div *ngIf="partner && selectPOS && selectPOS.POSID===11">
        <app-link-northmill [partner]="partner" [selectedPOS]="selectPOS" [modal]="modal"></app-link-northmill>
      </div>
      <div *ngIf="partner && selectPOS && selectPOS.POSID===12">
        <app-link-retailexpress [partner]="partner" [selectedPOS]="selectPOS" [modal]="modal"></app-link-retailexpress>
      </div>
      <div *ngIf="partner && selectPOS && selectPOS.POSID===13">
        <app-link-citruslime [partner]="partner" [selectedPOS]="selectPOS" [modal]="modal"></app-link-citruslime>
      </div>
      <div *ngIf="partner && selectPOS && selectPOS.POSID===14">
        <app-link-eposnow [partner]="partner" [selectedPOS]="selectPOS" [modal]="modal"></app-link-eposnow>
      </div>
      <div *ngIf="partner && selectPOS && selectPOS.POSID===15">
        <app-link-wilmar [partner]="partner" [selectedPOS]="selectPOS" [modal]="modal"></app-link-wilmar>
      </div>
      <div *ngIf="partner && selectPOS && selectPOS.POSID===16">
        <app-link-netsuite [partner]="partner" [selectedPOS]="selectPOS" [modal]="modal"></app-link-netsuite>
      </div>
      <div *ngIf="partner && selectPOS && selectPOS.POSID===17">
        <app-link-square [partner]="partner" [selectedPOS]="selectPOS" [modal]="modal"></app-link-square>
      </div>
      <div *ngIf="partner && selectPOS && selectPOS.POSID===19">
        <app-link-heartlands [partner]="partner" [selectedPOS]="selectPOS" [modal]="modal"></app-link-heartlands>
      </div>
      <div *ngIf="partner && selectPOS && selectPOS.POSID===10">
        <app-link-dear [partner]="partner" [selectedPOS]="selectPOS" [modal]="modal"></app-link-dear>
      </div>

      <div *ngIf="partner && selectPOS && selectPOS.POSID===20">
        <app-link-teamwork [partner]="partner" [selectedPOS]="selectPOS" [modal]="modal"></app-link-teamwork>
      </div>
      <div *ngIf="partner && selectPOS && selectPOS.POSID===21">
        <app-link-erply [partner]="partner" [selectedPOS]="selectPOS" [modal]="modal"></app-link-erply>
      </div>
      <div *ngIf="partner && selectPOS && selectPOS.POSID===22">
        <app-link-ascend [partner]="partner" [selectedPOS]="selectPOS" [modal]="modal"></app-link-ascend>
      </div>

    </div>
  </div>
</div>
